/**
 * style
 *  */
 import "./../style/app.scss";
/**
 * libs
 *  */
// import "./_libs/jquery.easings.min";
import barba from "@barba/core";
// import barbaCss from "@barba/css";
import barbaPrefetch from "@barba/prefetch";
import { gsap } from "gsap";

/**
 * modules
 *  */
import { ua } from "./_module/ua";
import { Global } from "./_module/global";
import { menu } from "./_module/_menu/menu";
import { PromotionBnr } from "./_module/_click/promotionBanner";
// import { LineModal } from "./_module/_click/lineModal";
// import { windowSize } from "./_module/windowSize";
import { Locomo } from "./_module/_scroll/locomo";
import { TopSnowAnimation } from "./_module/_animation/topSnowAnimation";
import { HeadSnowAni } from "./_module/_animation/headSnowAnimation";
// import { Cursor } from "./_module/_pointer/cursor";
import { Opening } from "./_module/_animation/opening";
import { LetterMotion } from "./_module/_text/letterMotion";
import { Ui } from "./_module/_animation/ui";
import { scrollHandle } from "./_module/_scroll/scrollhandle";
// import { SwiperContainer } from "./_module/_carousel/swiper";
/**
 * pages
 *  */
import { Home } from "./_page/index";
import { Store } from "./_page/store";
import { Product } from "./_page/product";
import { Gallery } from "./_page/gallery";
import { News } from "./_page/news";
import { NewsLow } from "./_page/newslow";
import { Contact } from "./_page/contact";
import { Privacy } from "./_page/privacy";
import { Faq } from "./_page/faq";
import { Company } from "./_page/company";


class Index {
  constructor() {
    if (ua() == "IE") {
      Global.isIE = true;
      alert("※ご利用中のブラウザはコンテンツが正常に表示されない可能性があります。アップデートいただくか最新のブラウザをご利用ください。");
    } else if (ua() == "MOBILE") {
      Global.isMobile = true;
    }
    Global.currentPage=document.querySelector('#page').dataset.page;
    this.directory();
  }

  directory() {
    LetterMotion.init(false)
    this.pageCurrent(Global.currentPage);
    this.init();
    menu.init();
    scrollHandle.noScroll();

    if(!Global.isIE){
      HeadSnowAni.setCanvas()
    }
    
    PromotionBnr.init();
    
    this.pageStart();
  }

  pageStart() {
    gsap.to(".wrap", 1, {
      autoAlpha: 1,
      onComplete: () => {
        Locomo.init(Global.currentPage);
        Locomo.scrollToTop();
        Global.isTrans = true;
        Locomo.headMotion();
        scrollHandle.returnScroll()
      }
    });
  }

  init() {
    Global.body.classList.add(ua());
    this.setBarba();
    // this.scroll();
  }

  pageCurrent(page) {
    for (let i = 0, li = Global.lowPageList.length; i < li; i++) {
      if (Global.lowPageList[i] == page) {
        page = page.replace(/-low/g, "");
      }
    }
    Global.menuItem.forEach(function(item){
      if(item.classList.contains("-"+page)){
        item.classList.add("is-active")
      }
    })
  }

  setBarba() {
    let self = this;
    barba.use(barbaPrefetch);
    barba.init({
      sync: true,
      transitions: [
        {
          beforeLeave(data) {            
            // return gsap.to(".snow-body",1.8,{
            //   onStart:()=>{
            //     SnowAnimation.play();
            //   },
            //   delay:1,
            //   y:0
            // });
            // SnowAnimation.playSegments();
            
            if(Global.isBanner){
              PromotionBnr.fadeOut();
            }
            gsap.to("#l-footer", .8, {autoAlpha: 0,});
            Global.isTrans = false;
          },
          leave(data) {
            return gsap.to(data.current.container, 1, {
              autoAlpha: 0,
              onStart: () => {
                if(data.current.namespace=="Home"){
                  Global.isAccess = true;
                  Global.isTopMvTimerActive=true;
                  Global.isTopMvTimerRestart=false;
                  TopSnowAnimation.initialize()
                  Product.cancelProductKeyVisual()
                }

                if(data.next.namespace == "Home" && Global.isAccess==false){
                  Ui.uiOff();
                }
                
              },
            });
          },
          afterLeave(data) {
            window.scrollTo(0, 0);
            // Cursor.cursorEvtRemove();
            // クラス等の書き換え
            // console.log("==== afterLeave ====")
            // console.log(data)
            document.querySelector("#page").dataset.page = data.next.namespace;
            document.querySelector("#page").classList.remove(data.current.namespace);
            document.querySelector("#page").classList.add(data.next.namespace);
            gsap.set(data.current.container, {
              position: "absolute",
              top: 0
            });
          },
          beforeEnter() {
            window.scrollTo(0, 0);
            // Cursor.cursorEvt();
            Locomo.destory();
          },
          afterEnter(data) {
            // console.log("==== afterEnter ====")
            // console.log(data)
            document.querySelector("#page").dataset.page = data.next.namespace;
            document.querySelector("#page").classList.remove(data.current.namespace);
            document.querySelector("#page").classList.add(data.next.namespace);
            setTimeout(() => {
              Global.isTrans = true;
              if(!Global.isIE){
                HeadSnowAni.setCanvas();
              }
              Locomo.headMotion();              
            }, 400);
          },
          enter(data) {
            return gsap.from(data.next.container, 0.6, {
              delay: .4,
              autoAlpha: 0,
              onStart: () => {
                Locomo.init(Global.currentPage);
                if(data.current.namespace=="News"){
                  Global.header.classList.remove("is-white")
                }
              },
              onComplete: () => {
                self.pageCurrent(data.next.namespace);
                Locomo.update();
              }
            });
          }
        }
      ],
      views: [
        //Home
        {
          namespace: "Home",
          beforeEnter(data) {
            Global.currentPage = "Home";
            Home.init();
            if(Global.isAccess){
              Opening.topPageReady()
            }
            else{
              Opening.init();
            }
          },
        },
        //Gallery
        {
          namespace: "Gallery",
          beforeEnter(data) {
            Global.currentPage = "Gallery";
            Gallery.init()
          }
        },
        // Product
        {
          namespace: "Product",
          beforeEnter(data) {
            Global.currentPage = "Product";
            // Product.init();
          },
          beforeLeave(){
            Product.cancelProductKeyVisual()
          },
          afterEnter() {
            setTimeout(()=>{
              Product.init();
              // Locomo.update()
              
            },800)
            
          }
        },
        // News
        {
          namespace: "News",
          beforeEnter(data) {
            Global.currentPage = "News";
            News.init()
          },
          afterEnter() {
            News.isWhite()
          }
        },
        // News-low
        {
          namespace: "News-low",
          beforeEnter(data) {
            Global.currentPage = "News-low";
            NewsLow.init()
          }
        },
        //Store
        {
          namespace: "Store",
          beforeEnter(data) {
            Global.currentPage = "Store";
            Store.init();
          }
        },
        //Contact
        {
          namespace: "Contact",
          beforeEnter(data) {
            Global.currentPage = "Contact";
            Contact.init()
          }
        },
        {
          namespace: "Contact-low",
          beforeEnter(data) {
            Global.currentPage = "Contact-low";
            Contact.init()
          }
        },
        // Privacypolicy
        {
          namespace: "Privacypolicy",
          beforeEnter(data) {
            Global.currentPage = "Privacypolicy";
            Privacy.init()
          }
        },
        // Company
        {
          namespace: "Company",
          beforeEnter(data) {
            Global.currentPage = "Company";
            Company.init()
          }
        },
        //faq
        {
          namespace: "Faq",
          beforeEnter(data) {
            Global.currentPage = "Faq";
            Faq.init()
          }
        },
      ]
    });
    // 同じURLの場合は遷移しない
    const eventDelete = e => {
      if (e.currentTarget.href === window.location.href) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
    };
    const links = [...document.querySelectorAll("a[href]")];
    links.forEach(link => {
      link.addEventListener(
        "click",
        e => {
          eventDelete(e);
        },
        false
      );
    });

    const replaceHeadTags = target => {
      const head = document.head;
      const targetHead = target.html.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0];
      const newPageHead = document.createElement("head");
      newPageHead.innerHTML = targetHead;
      const removeHeadTags = [
        "meta[name='keywords']",
        "meta[name='description']",
        "meta[property^='fb']",
        "meta[property^='og']",
        "meta[name^='twitter']",
        "meta[name='robots']",
        "meta[itemprop]",
        "link[itemprop]",
        "link[rel='prev']",
        "link[rel='next']",
        "link[rel='canonical']"
      ].join(",");
      const headTags = [...head.querySelectorAll(removeHeadTags)];
      headTags.forEach(item => {
        head.removeChild(item);
      });
      const newHeadTags = [...newPageHead.querySelectorAll(removeHeadTags)];
      newHeadTags.forEach(item => {
        head.appendChild(item);
      });
    };
    // gtm
    barba.hooks.after(() => {
      if(window.ga){
        ga('create', 'UA-187205026-3', 'auto');
        ga('send', 'pageview', window.location.pathname);
      }
    });
    // ga
    // barba.hooks.after(data => {
    //   if (typeof gtag === "function") {
    //     gtag("config", window.GA_MEASUREMENT_ID, {
    //       page_path: window.location.pathname
    //     });
    //   }
    // });
    barba.hooks.beforeEnter(({ next }) => {
      window.scrollTo(0, 0);
      replaceHeadTags(next);
    });
  }

  // scroll() {
  //   let setTimeoutId = null;
  //   window.addEventListener("scroll", e => {
  //     if (setTimeoutId) clearTimeout(setTimeoutId);
  //     setTimeoutId = setTimeout(() => {


  //       setTimeoutId = null;
  //     }, 5);
  //   });
  // }

  getOpeningTimes(c_name) {
    let s;
    let n;
    let m;
    let c_data;
    //cookieの読み込み
    c_data = document.cookie;
    //cookie名
    c_name = c_name + "=";
    //有効なcookie名を調べる
    n = c_data.indexOf(c_name, 0);
    if (n > -1) {
      //cookieのデータ部分を取り出す
      m = c_data.indexOf(";", n + c_name.length);
      if (m == -1) m = c_data.length;
      s = c_data.substring(n + c_name.length, m);
      //デコード
      return unescape(s);
    } else {
      return "";
    }
  }
  countOpeningTimes() {
    let c_name;
    let count;
    //cookie名
    c_name = "visit_top";

    //cookieの読込
    count = this.getOpeningTimes(c_name);
    if (count == "") {
      //データがない場合
      count = 1;
    } else if (count >= 3) {
      count = 1;
    } else {
      //データがある場合
      count++;
    }
    //cookieの保存
    return this.setOpeningTimes(c_name, count, 60);
  }

  setOpeningTimes(c_name, c_data, c_day) {
    let n;
    let c_date;
    let c_limit;
    //有効期限
    c_date = new Date();
    n = c_date.getTime() + 1000 * 60 * 60 * 24 * c_day;
    c_date.setTime(n);
    c_limit = c_date.toGMTString();
    //cookieの書き出し
    document.cookie = c_name + "=" + escape(c_data) + "; expires=" + c_limit;
    return c_data;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new Index();
});
